import { FinaleStockField } from "@redotech/congo-enums/finale-stock-field";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const finaleSettings = defineIntegrationSettings({
  fields: {
    enabled: z.boolean(),
    stockField: createEnum(FinaleStockField),
    onHandField: createEnum(FinaleStockField).nullable(),
    includeBomStock: z.boolean(),
    useAsInventorySource: z.boolean(),
  },
  secrets: {},
  connectOnly: {
    accountPath: z.string().trim().min(1, "Account path is required"),
    apiKey: z.string().trim().min(1, "API key is required"),
    apiSecret: z.string().trim().min(1, "API secret is required"),
  },
  computed: {
    accountPath: z.string(),
    authError: z.boolean(),
    inventoryLastSyncedAt: z.date().nullable(),
  },
});
